import cx from 'classnames';
import Markdown from 'markdown-to-jsx';
import React from 'react';

import { ASSISTANT_TEXTS } from '../../texts';
import CrewMemberList from '../CrewMemberList';
import DriverResultCard from '../DriverResultCard';
import MessageActionOverlay from '../MessageActionOverlay';
import MessageAvatar from '../MessageAvatar';
import SuggestChips from '../SuggestChips';
import { useMessageBubble } from './useMessageBubble';

import styles from '../../styles.module.css';

const renderCard = (card) => {
	if (card.type === 'crewMembers') return <CrewMemberList crewMembers={card.data} />;
	if (card.type === 'crewMember') return <DriverResultCard crewMember={card.data} />;
	return null;
};

const MessageBubble = ({ msg, onEditAndAsk, onResend }) => {
	const isBot = msg.role === 'assistant';

	const {
		overlayRect,
		bubbleRef,
		closeOverlay,
		handleContextMenu,
		handleCopy,
		handleEditAndAsk,
		handleResend,
	} = useMessageBubble({ text: msg.text, onEditAndAsk, onResend });

	return (
		<>
			<div className={cx(styles.msgRow, { [styles.msgRowUser]: !isBot })}>
				<MessageAvatar role={msg.role} />
				<div className={cx(styles.msgContent, { [styles.msgRowUser]: !isBot })}>
					<div className={styles.msgSender}>{isBot ? ASSISTANT_TEXTS.senderName : 'You'}</div>
					<div
						ref={!isBot ? bubbleRef : undefined}
						className={cx(styles.msgBubble, {
							[styles.msgBubbleBot]: isBot,
							[styles.msgBubbleUser]: !isBot,
						})}
						tabIndex={!isBot ? 0 : undefined}
						onContextMenu={!isBot ? handleContextMenu : undefined}
					>
						{isBot ? (
							<div className={styles.markdownContent}>
								<Markdown>{msg.text}</Markdown>
							</div>
						) : (
							msg.text
						)}
						{isBot && msg.card && renderCard(msg.card)}
						{isBot && msg.suggestions && (
							<SuggestChips chips={msg.suggestions} onSelect={() => {}} />
						)}
					</div>
					<div className={styles.msgTime}>{msg.time}</div>
				</div>
			</div>
			{overlayRect && (
				<MessageActionOverlay
					originRef={bubbleRef}
					messageRect={overlayRect}
					onCopy={handleCopy}
					onEditAndAsk={handleEditAndAsk}
					onResend={handleResend}
					onClose={closeOverlay}
				/>
			)}
		</>
	);
};

export default MessageBubble;
